import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";

// T10 / T13 (titipan auditor 26 Okt 2026): permintaan customer dari Ruang Pesanan untuk layar desain —
// Tugas Desainer dan Review Desain SPV. Satu komponen untuk dua layar supaya desainer dan SPV membaca
// HAL YANG SAMA (gerbang K55 menilai "sesuai permintaan customer"). Jumlah di sini adalah jumlah yang
// customer KONFIRMASI — angka PD di layar lain hanya perkiraan awal.
// Isinya disusun server dari daftar ruas tertutup (`services/brief_desain.py`): alamat/pengiriman tidak ikut.
// K228 (BUSINESS-106): nama tim + daftar nama/nomor/ukuran ikut untuk desainer & SPV — tanpa HP, alamat, harga.

function Baris({ k, v }) {
  if (v === null || v === undefined || v === "") return null;
  return (
    <div className="flex justify-between gap-4 border-b border-border py-1.5 text-sm last:border-0">
      <span className="text-muted-foreground">{k}</span>
      <span className="text-right font-medium">{v}</span>
    </div>
  );
}

export function isiBrief(b) {
  if (!b?.ada) return [];
  return [
    ["Nama tim", b.nama_tim],
    ["Warna utama", b.warna],
    ["Kombinasi warna", b.kombinasi_warna],
    ["Kerah", b.jenis_kerah],
    ["Lengan", b.jenis_lengan],
    ["Pola", b.jenis_pola],
    ["Jumlah jersey (atasan)", b.qty_atasan],
    ["Jumlah celana", b.qty_celana],
  ];
}

export default function BriefCustomer({ drId, ringkas = false }) {
  const [b, setB] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let hidup = true;
    if (!drId) return undefined;
    api.get(`/design-requests/${drId}/brief-customer`)
      .then((r) => { if (hidup) setB(r.data); })
      .catch((e) => { if (hidup) setErr(apiErrorMessage(e, "Permintaan customer gagal dimuat.")); });
    return () => { hidup = false; };
  }, [drId]);

  if (err) return <div className="text-sm text-danger-soft-foreground" data-testid="brief-customer-error">{err}</div>;
  if (!b) return <div className="text-sm text-muted-foreground">Memuat permintaan customer…</div>;
  if (!b.ada) {
    return (
      <div className="text-sm text-muted-foreground italic" data-testid="brief-customer-kosong">
        Customer belum mengisi rincian desain di Ruang Pesanan.
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="brief-customer">
      <div className="text-xs text-muted-foreground">
        {b.terkunci ? "Sudah dikonfirmasi customer." : "Belum dikonfirmasi customer — isinya masih bisa berubah."}
      </div>
      <div>
        {isiBrief(b).map(([k, v]) => <Baris key={k} k={k} v={v} />)}
      </div>

      {b.logo_sponsor?.length > 0 && (
        <div data-testid="brief-customer-sponsor">
          <div className="text-xs font-medium text-muted-foreground mb-1">
            Logo sponsor (posisi dilihat dari sudut pandang orang yang memakai jersey)
          </div>
          {b.logo_sponsor.map((s, i) => <Baris key={i} k={s.nama} v={s.posisi || "posisi belum dipilih"} />)}
        </div>
      )}

      {(b.logo_tim_url || b.referensi?.length > 0) && (
        <div>
          <div className="text-xs font-medium text-muted-foreground mb-1">Logo tim & contoh desain dari customer</div>
          <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
            {[b.logo_tim_url, ...(b.referensi || [])].filter(Boolean).map((u, i) => (
              <a key={i} href={u} target="_blank" rel="noopener noreferrer" title="Buka ukuran penuh">
                <img src={u} alt={i === 0 && b.logo_tim_url ? "Logo tim" : "Contoh desain"}
                     className="h-20 w-full rounded border border-border object-cover bg-muted" />
              </a>
            ))}
          </div>
        </div>
      )}

      {!ringkas && b.roster?.length > 0 && (
        <div data-testid="brief-customer-roster">
          <div className="text-xs font-medium text-muted-foreground mb-1">Daftar nama ({b.roster.length} baris)</div>
          <table className="w-full text-sm">
            <thead className="text-xs text-muted-foreground border-b">
              <tr><th className="text-left py-1">Nama punggung</th><th className="text-left">Nomor</th><th className="text-left">Ukuran</th></tr>
            </thead>
            <tbody>
              {b.roster.map((r, i) => (
                <tr key={i} className="border-b border-border last:border-0">
                  <td className="py-1">{r.nameset_punggung || "—"}</td>
                  <td>{r.nomor_punggung || "—"}</td>
                  <td>{r.ukuran_dewasa || (r.ukuran_anak ? `Anak ${r.ukuran_anak}` : "—")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {ringkas && b.roster?.length > 0 && (
        <div className="text-xs text-muted-foreground">Daftar nama: {b.roster.length} baris.</div>
      )}
    </div>
  );
}
